import { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { AppColors } from "../../resources/AppColors";
import ChartCard from "./ChartCard";
import DateNavigation from "components/DateNavigation";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);
const optionsWithLines = {
  maintainAspectRatio: false,
  plugins: {
    autocolors: false,
    annotation: {
      annotations: {
        line1: {
          type: "line",
          yMin: 5000,
          yMax: 5000,
          borderColor: AppColors.RED_CHART,
          borderWidth: 1,
        },
        line2: {
          type: "line",
          yMin: 10000,
          yMax: 10000,
          borderColor: AppColors.GREEN_CHART,
          borderWidth: 1,
        },
      },
    },
  },
};
const optionsWithoutLines = {
  maintainAspectRatio: false,
};

const LineChartDateArrows = ({
  dataToShow,
  title,
  hasLines,
  selectedDate,
  setSelectedDate,
  minDate,
  maxDate,
  interval,
}) => {
  let dataSets = [];
  Object.keys(dataToShow).map(function (data) {
    if (data !== "labels") {
      dataSets.push(dataToShow[data]);
    }
  });

  const data = useMemo(
    function () {
      return {
        datasets: dataSets,
        labels: dataToShow.labels,
      };
    },
    [dataSets, dataToShow.labels]
  );

  return (
    <DateNavigation
      title={title}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      minDate={minDate}
      maxDate={maxDate}
      interval={interval}
    >
      <Line
        data={data}
        options={hasLines ? optionsWithLines : optionsWithoutLines}
        style={{ height: "100%" }}
      />
    </DateNavigation>
  );
};

export default LineChartDateArrows;
